<div
  class="-mt-6 bg-gray-100 absolute h-auto z-50 shadow-md"
  [ngClass]="commonClass"
  >
  @if (expand) {
    <div class="absolute left-0 border-gray-400 text-gray-400 w-6">
      <img
        (click)="expandCollapse()"
        class="h-5 w-5 cursor-pointer"
        [src]="expand"
        alt="Open filter"
      />
    </div>
  }
  @if (filterOpen) {
    <div
      class="border-r pb-5 border-b-0 border-gray-40 min-h-screen shadow-md"
      >
      <form [formGroup]="commonFilter">
        <div class="flex flex-row border-b border-gray-400 justify-between">
          <div class="ml-6 mt-1 mb-1 text-sm font-bold">FILTER BY</div>
          <div
            class="cursor-pointer flex items-center pr-0.5"
            (click)="expandCollapse()"
            >
            <img [src]="collapse" alt="Close filter" class="h-5 w-5" />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-1 mr-4">
          <div class="mt-1.5 mb-1 flex flex-col">
            <div class="ml-6 mb-1 text-sm font-medium">Apps</div>
            <div class="flex md:flex-row sm:flex-col ml-4 pr-4 w-full">
              <gdx-multiselect-dropdown
                [id]="'ddApp'"
                [name]="'ddApp'"
                class="w-full"
              [class]="
                'ml-1 w-full border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                [control]="'selectedApp'"
                [options]="apps"
                [optionLabel]="'name'"
                [placeholder]="allSelectPlaceHolder"
                [filter]="true"
                [parentForm]="commonFilter"
                [disabled]="isAppDisabled"
                >
              </gdx-multiselect-dropdown>
            </div>
          </div>
          <div class="mt-1.5 mb-1 flex flex-col">
            <div class="ml-6 mb-1 text-sm font-medium">
              Select Period
              <span class="text-red">*</span>
              <span
                ><img
                src="../../../assets/images/info.svg"
                title="Selected period will be converted to UTC timezone"
                alt="info"
                class="inline cursor-pointer ml-1 -mt-1"
                width="16"
                height="16"
              /></span>
            </div>
            <div class="flex md:flex-col sm:flex-col ml-4 pr-4 w-full">
              <div>
                <gdx-date-picker
                  [id]="'selectedperiod'"
                  [name]="'period'"
                  class="w-full"
                  [class]="'w-full ml-1 z-100'"
                  [inputStyleClass]="'border border-gray-300'"
                  [placeholder]="'Select Date Range'"
                  [showIcon]="true"
                  [required]="false"
                  [showTime]="false"
                  [control]="'selectedPeriod'"
                  [parentForm]="commonFilter"
                  [selectionMode]="'range'"
                  [maxDate]="maxDate"
                  [baseZIndex]="999999999"
                  [readonlyInput]="false"
                  >
                </gdx-date-picker>
              </div>
              <div class="text-xs text-red-600 ml-1">
                {{ errorMessage }}
              </div>
            </div>
          </div>
          <div class="mt-1 mb-1 flex flex-col">
            <div class="ml-6 mb-1 text-sm font-medium">
              User ID
              <span
                ><img
                src="../../../assets/images/info.svg"
                title="User can pass multiple User ID with comma separated value"
                alt="info"
                class="inline cursor-pointer ml-1 -mt-1"
                width="16"
                height="16"
              /></span>
            </div>
            <div class="flex md:flex-row sm:flex-col ml-4 pr-3 w-full">
              <gdx-input-box
                [type]="'text'"
                [id]="'txtUserId'"
                [name]="'txtUserId'"
                [control]="'selectedUserId'"
                [placeholder]="'User ID'"
                [disabled]="false"
                [textClass]="'w-full ml-1'"
                [parentForm]="commonFilter"
                class="w-full"
                >
              </gdx-input-box>
            </div>
          </div>
          <div class="mt-1 mb-1 flex flex-col">
            <div class="ml-6 mb-1 text-sm font-medium">Esign Reason</div>
            <div class="flex md:flex-row sm:flex-col ml-4 pr-4 w-full">
              <gdx-multiselect-dropdown
                [id]="'ddlEsignReason'"
                [name]="'ddlEsignReason'"
                class="w-full"
              [class]="
                'ml-1 w-full border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                [control]="'selectedEsignReason'"
                [options]="esignReasons"
                [optionLabel]="'name'"
                [placeholder]="allSelectPlaceHolder"
                [filter]="true"
                [parentForm]="commonFilter"
                >
              </gdx-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="mt-1.5 mb-1 flex flex-col">
          <div class="ml-6 mb-1 text-sm font-medium">Advanced Filters</div>
          @if (!isAdvanced) {
            <div
              class="cursor-pointer -mt-7 ml-40 w-6"
              (click)="expandCollapseAdvanced()"
              >
              {{ advanced }}
            </div>
          }
          @if (isAdvanced) {
            <div
              class="cursor-pointer -mt-7 ml-40 w-6"
              (click)="expandCollapseAdvanced()"
              >
              {{ notAdvanced }}
            </div>
          }
        </div>
        @if (isAdvanced) {
          <div class="grid grid-cols-2 gap-1">
            <div class="mb-1 flex flex-col w-full">
              <div class="ml-6 mb-1 text-sm font-medium">Role</div>
              <div class="flex md:flex-row sm:flex-col ml-2 pr-4">
                <gdx-multiselect-dropdown
                  [id]="'ddlRole'"
                  [name]="'ddlRole'"
                  class="w-full"
              [class]="
                'ml-3 w-44 border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                  [control]="'selectedRole'"
                  [options]="rolesData"
                  [optionLabel]="'name'"
                  [placeholder]="allSelectPlaceHolder"
                  [filter]="true"
                  [parentForm]="commonFilter"
                  >
                </gdx-multiselect-dropdown>
              </div>
            </div>
            <div class="mb-1 flex flex-col">
              <div class="ml-4 mb-1 text-sm font-medium">Event</div>
              <div class="flex md:flex-row sm:flex-col pr-6">
                <gdx-multiselect-dropdown
                  [id]="'ddlEvent'"
                  [name]="'ddlEvent'"
                  class="w-full"
              [class]="
                'ml-3 w-full border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                  [control]="'selectedEvent'"
                  [options]="events"
                  [optionLabel]="'name'"
                  [placeholder]="allSelectPlaceHolder"
                  [filter]="true"
                  [parentForm]="commonFilter"
                  >
                </gdx-multiselect-dropdown>
              </div>
            </div>
            <div class="mb-1 flex flex-col">
              <div class="ml-6 mb-1 text-sm font-medium">Category</div>
              <div class="flex md:flex-row sm:flex-col ml-2 pr-4">
                <gdx-multiselect-dropdown
                  [id]="'ddlCategory'"
                  [name]="'ddlCategory'"
                  class="w-full"
              [class]="
                'ml-3 w-full border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                  [control]="'selectedCategory'"
                  [optionLabel]="'name'"
                  [options]="categories"
                  [placeholder]="allSelectPlaceHolder"
                  [filter]="true"
                  [parentForm]="commonFilter"
                  >
                </gdx-multiselect-dropdown>
              </div>
            </div>
            <div class="mb-1 flex flex-col">
              <div class="ml-4 mb-1 text-sm font-medium">Status</div>
              <div class="flex md:flex-row sm:flex-col pr-6">
                <gdx-dropdown
                  [id]="'ddlStatus'"
                  [name]="'ddlStatus'"
                  class="w-full"
              [class]="
                'ml-3 w-full border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                  [control]="'selectedStatus'"
                  [options]="status"
                  [optionLabel]="'name'"
                  [placeholder]="allSelectPlaceHolder"
                  [filter]="false"
                  [parentForm]="commonFilter"
                  >
                </gdx-dropdown>
              </div>
            </div>
            <div class="mb-1 flex flex-col">
              <div class="ml-6 mb-1 text-sm font-medium">Action</div>
              <div class="flex md:flex-row sm:flex-col ml-2 pr-4">
                <gdx-multiselect-dropdown
                  [id]="'ddlAction'"
                  [name]="'ddlAction'"
                  class="w-full"
              [class]="
                'ml-3 w-full border border-gray-300 hover:border-gray-300 focus:outline-none focus:shadow-none focus:border-gray-500 small-font-pdropdown'
              "
                  [control]="'selectedAction'"
                  [optionLabel]="'name'"
                  [options]="actions"
                  [placeholder]="allSelectPlaceHolder"
                  [filter]="true"
                  [parentForm]="commonFilter"
                  >
                </gdx-multiselect-dropdown>
              </div>
            </div>
          </div>
        }
        <div class="h-7 pr-1 flex justify-end w-full mt-4 mr-3">
          <div class="1/4 mr-2">
            <gdx-button
              [id]="'btn_filter-apply'"
              [type]="btnType.test"
              [text]="'Reset'"
              (clicked)="resetFilter()"
              >
            </gdx-button>
          </div>
          <div class="1/4 mr-3">
            <gdx-button
              [id]="'btn_filter-apply'"
              [type]="btnType.primary"
              [text]="'Apply'"
              (clickEvent)="applyFilter($event)"
              >
            </gdx-button>
          </div>
        </div>
      </form>
    </div>
  }
</div>
